export enum FORM_TEMPLATE {
  DEFAULT = "xxx",
  TABLE = "tbl",
  HIDDEN = "hid",
  HEADER = "kop",
}
